import React from "react";
import styles from "../../../LocationForm.module.css";
import {ValidationResult} from "../../../../../../../elements/validator/component/ValidationComponent";
import {NotEmptyStringValidator} from "../../../../../../../elements/validator/Validator";
import {ConfigurationRegion} from "../../../../../../../../api/generated";
import {
    LocationFormSelectionProvider,
    LocationRequest,
    LocationRequestPartial,
    WorkingHoursRequest
} from "../../../LocationForm";
import {ValidatedSelectField} from "../../../../../../../elements/validator/component/ValidatedSelectField";
import {configurationRegionOptions} from "../../../../../types/configurationRegionOptions";

interface Props<T, W> {
    getMessage: (s: any) => any;
    updateRequest: (update: LocationRequestPartial) => void;
    selectionProvider: LocationFormSelectionProvider<W>;
    updateValidationStatus: (status: ValidationResult<T>) => void,
}

export const Em2Fields = <
    T extends LocationRequest,
    W extends WorkingHoursRequest
>({
      getMessage,
      updateRequest,
      selectionProvider,
      updateValidationStatus
  }: Props<T, W>) => {

    return <div className={styles.fieldsLine}>
        <ValidatedSelectField<ConfigurationRegion, T>
            onChange={(v) => updateRequest({em2Region: v})}
            updateValidationStatus={updateValidationStatus}
            fieldName={"em2Region"}
            selector={selectionProvider.em2Region}
            validator={NotEmptyStringValidator}
            label={"Region"}
            options={configurationRegionOptions}
            getMessage={getMessage}
        />
    </div>
}
